function hideSubmenus(): void {
  const submenus = document.getElementsByClassName("site--submenu");
  for (let i = 0; i < submenus.length; i++) {
    const submenu = submenus[i];
    submenu.setAttribute("hidden", "");
  }

  const menuLinks = document.getElementsByClassName("site--menu-item-link");
  for (let i = 0; i < menuLinks.length; i++) {
    menuLinks[i].setAttribute("aria-expanded", "false");
  }
}

function launchSubmenu(event: Event): void {
  event.preventDefault();
  const target = <Element>event.target;
  const targetId = target.getAttribute("aria-controls");
  const submenu = document.getElementById(targetId);

  if (submenu.getAttribute("hidden") !== null) {
    hideSubmenus();
    submenu.removeAttribute("hidden");
    target.setAttribute("aria-expanded", "true");
  } else {
    hideSubmenus();
  }
}

function mobileMenuUnhide(): void {
  document.getElementById("siteNavigation").removeAttribute("hidden");
}

function mobileMenuHide(): void {
  document.getElementById("siteNavigation").setAttribute("hidden", "");
}

export default (): void => {
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      document.body.addEventListener("mousedown", function() {
        document.body.classList.add("using-mouse");
      });
      document.body.addEventListener("keydown", function() {
        document.body.classList.remove("using-mouse");
      });

      /**
       * controls for submenu links
       */
      const menuLinks = document.getElementsByClassName("site--menu-item-link");
      if (menuLinks.length > 0)
        for (let i = 0; i < menuLinks.length; i++) {
          const menuLink = menuLinks[i];
          const thisItem = menuLink.getAttribute("data-this-count");
          const count = menuLink.getAttribute("data-count");

          // launch submenu on click
          menuLink.addEventListener("click", (event: MouseEvent) => {
            if (menuLink.hasAttribute("aria-controls")) launchSubmenu(event);
          });
        }

      /**
       * keyboard controls for submenu links
       */
      const submenuLinks = document.querySelectorAll(
        ".site--submenu-link-list a"
      );
      if (submenuLinks.length > 0)
        for (let i = 0; i < submenuLinks.length; i++) {
          const submenuLink = submenuLinks[i];
          const thisItem = Number(submenuLink.getAttribute("data-this-count"));
          const count = Number(submenuLink.getAttribute("data-count"));
          const thisColumn = Number(
            submenuLink.getAttribute("data-this-column")
          );
          const columnCount = Number(
            submenuLink.getAttribute("data-count-columns")
          );

          submenuLink.addEventListener("keydown", (event: KeyboardEvent) => {
            const target = <Element>event.target;
            const submenu = <Element>target.parentNode.parentNode;
            const submenus = <Element>submenu.parentNode.parentNode;

            if (event.key === "ArrowUp" && thisItem !== 1) {
              const newLink: HTMLElement = submenu.querySelector(
                `[data-this-count="${thisItem - 1}"]`
              );
              newLink.focus();
            }

            if (event.key === "ArrowDown" && thisItem !== count) {
              const newLink: HTMLElement = submenu.querySelector(
                `[data-this-count="${thisItem + 1}"]`
              );
              newLink.focus();
            }

            if (event.key === "ArrowLeft" && thisColumn !== 1) {
              const newLink: HTMLElement = submenus.querySelector(
                `[data-this-column="${thisColumn - 1}"]`
              );
              newLink.focus();
            }

            if (event.key === "ArrowRight" && thisColumn < columnCount) {
              const newLink: HTMLElement = submenus.querySelector(
                `[data-this-column="${thisColumn + 1}"]`
              );
              newLink.focus();
            }
          });
        }

      /**
       * collapse any open submenu with ESC
       */
      document.addEventListener("keydown", event => {
        if (event.key === "Escape") hideSubmenus();
      });

      /**
       * collapse any open submenu with external click
       */
      function getPath(event): any {
        if (event.composedPath) {
          return event.composedPath();
        }

        let path = [];
        let target = event.target;

        while (target.parentNode) {
          path.push(target);
          target = target.parentNode;
        }

        path.push(document, window);

        return path;
      }

      function trackMenuSideEvents(targetClass): any {
        return event => {
          const path = getPath(event);

          if (path && path.length > 0) {
            const eventFromMenu = path.filter(el => {
              return el.classList && el.classList.contains(targetClass);
            });

            if (eventFromMenu.length == 0) hideSubmenus();
          }
        };
      }

      document.addEventListener(
        "click",
        trackMenuSideEvents("site--navigation")
      );
      document.addEventListener(
        "focusin",
        trackMenuSideEvents("site--submenu")
      );

      /**
       * mobile menu control
       */
      const menuButton = document.getElementById("menuButton");
      menuButton &&
        menuButton.addEventListener("click", () => {
          if (menuButton.getAttribute("aria-expanded") === "false") {
            mobileMenuUnhide();
            menuButton.setAttribute("aria-expanded", "true");
          } else {
            mobileMenuHide();
            menuButton.setAttribute("aria-expanded", "false");
          }
        });

      /**
       * mobile submenu closure
       */
      const submenuClose = document.getElementsByClassName(
        "site--submenu-back"
      );
      if (submenuClose.length > 0)
        for (let i = 0; i < submenuClose.length; i++) {
          submenuClose[i].addEventListener("click", (): void => {
            hideSubmenus();
          });
        }
    },
    {
      once: true
    }
  );
};